var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchSmall = function SvgSearchSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    d: "m10.375 10.387 2.904 2.904"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.417,
    cy: 6.417,
    r: 5.417,
    stroke: "#fff"
  })));
};
export { SvgSearchSmall as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0IiBmaWxsPSJub25lIj4KICA8bGluZSB4MT0iMTAuMzc0OCIgeTE9IjEwLjM4NjciIHgyPSIxMy4yNzkyIiB5Mj0iMTMuMjkxMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgPGNpcmNsZSBjeD0iNi40MTcxNyIgY3k9IjYuNDE3MTciIHI9IjUuNDE3MTciIHN0cm9rZT0id2hpdGUiLz4KPC9zdmc+";